import Action from "../../classes/Action";
import { StepUIData } from "../../interfaces/UITemplateData";
import store, { StoreActions } from '../../state/store';

export default class ResetTemplateAction extends Action
{
	constructor(slide: string)
	{
		const previousValue: StepUIData = { ...store.getState().uiModule.slideMaster[slide] };

		super(
			[slide],
			[slide, previousValue],
			`Reset Template ${previousValue.name ?? ""}`,
			[previousValue]
		);
	}

	do(slide: string)
	{
		store.dispatch(StoreActions.ui.setActiveTemplateForStep({
			slide: slide,
			reset: true
		}));
	}

	undo(slide: string, previousValue: StepUIData)
	{
		store.dispatch(StoreActions.ui.setSlideFromCopy({
			slide: slide,
			content: previousValue
		}));
	}

	verify(previousValue: StepUIData)
	{
		if (!previousValue) return false;
		return true;
	}
}
